import React from 'react';
import { 
  Card, 
  CardHeader, 
  CardContent, 
  Divider, 
  Grid, 
  Button, 
  Typography 
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PaymentIcon from '@mui/icons-material/Payment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useNavigate } from 'react-router-dom';

/**
 * QuickActions Component
 * Displays a card with quick action buttons for common admin tasks
 */
const QuickActions = () => {
  const navigate = useNavigate();
  
  const actions = [
    {
      title: 'New Customer',
      description: 'Add a new customer manually',
      icon: <PersonAddIcon />,
      color: 'primary',
      onClick: () => navigate('/admin/customers/new')
    },
    {
      title: 'Record Payment',
      description: 'Record a new payment',
      icon: <PaymentIcon />,
      color: 'secondary',
      onClick: () => navigate('/admin/payments/new')
    },
    {
      title: 'Export Data',
      description: 'Generate reports',
      icon: <AssessmentIcon />,
      color: 'info',
      onClick: () => navigate('/admin/reports')
    }
  ];
  
  return (
    <Card>
      <CardHeader title="Quick Actions" />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          {actions.map((action, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Button
                variant="outlined"
                color={action.color}
                startIcon={action.icon}
                fullWidth
                onClick={action.onClick}
                sx={{ 
                  py: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '100%',
                  justifyContent: 'center'
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {action.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {action.description}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickActions;